export default __webpack_public_path__ + "static/media/_DSC7505.77b66a3c.jpg";